module.exports = __webpack_public_path__ + "static/p7.f93d03e6.jpg";